
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getBlockgroup",
      resolverType: "query",
      routePath: "/getBlockgroup",
      httpMethod: "POST",
    });
  